import { Looks3TwoTone, Looks4TwoTone, Looks5TwoTone, LooksOneTwoTone, LooksTwoTwoTone } from "@mui/icons-material";
import { Box, Rating, Typography } from "@mui/material";
import { amber, deepOrange, green, red, teal } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";

const useStyles = makeStyles({
  root: {
    width: 200,
    display: "flex",
    alignItems: "center",
  },
  label: {
    fontWeight: 600,
    fontSize: 12,
    whiteSpace: "nowrap",
  },
});

const NumberRating = (props) => {
  const classes = useStyles();
  const { value, setValue, disabled, name, question } = props;
  const [hover, setHover] = useState(value);

  const customIcons = {
    1: {
      icon: (
        <LooksOneTwoTone
          fontSize="large"
          style={
            value === 1 || hover === 1
              ? { color: red[900] }
              : { color: red[100] }
          }
        />
      ),
      label: "Not Satisfied",
    },
    2: {
      icon: (
        <LooksTwoTwoTone
          fontSize="large"
          style={
            value === 2 || hover === 2
              ? { color: deepOrange[900] }
              : { deepOrange: red[100] }
          }
        />
      ),
      label: "Needs Improvement",
    },
    3: {
      icon: (
        <Looks3TwoTone
          fontSize="large"
          style={
            value === 3 || hover === 3
              ? { color: amber[900] }
              : { color: amber[100] }
          }
        />
      ),
      label: "Acceptable",
    },
    4: {
      icon: (
        <Looks4TwoTone
          fontSize="large"
          style={
            value === 4 || hover === 4
              ? { color: green[900] }
              : { color: green[100] }
          }
        />
      ),
      label: "Satisfied",
    },
    5: {
      icon: (
        <Looks5TwoTone
          fontSize="large"
          style={
            value === 5 || hover === 5
              ? { color: teal[900] }
              : { color: teal[100] }
          }
        />
      ),
      label: "Very Satisfied",
    },
  };

  const IconContainer = (props) => {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
  };

  return (
    <div style={{ paddingTop: 20 }}>
      <Box component="fieldset" mb={3} borderColor="transparent">
        <Typography component="legend">{question}</Typography>
        <div className={classes.root}>
          <Rating
            disabled={disabled}
            name={name}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            onChangeActive={(event, newHover) => {
              setHover(newHover);
            }}
            getLabelText={(value) => customIcons[value].label}
            IconContainerComponent={IconContainer}
          />
          {(value !== -1 || hover !== -1) && (
            <Box ml={2} className={classes.label}>
              {customIcons[hover !== -1 ? hover : value].label}
            </Box>
          )}
        </div>
      </Box>
    </div>
  );
};

export default NumberRating;